const courtListToast = (state = null, action) => {
  if (action.type === "SET_COURT_LIST_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_COURT_LIST_TOAST": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default courtListToast;
